const UserProfileTypes = {

    SET_USER_DETAILS : 'SET_USER_DETAILS',

    GET_USER_PROFILE : {
        SUCCESS: 'GET_USER_PROFILE_SUCCESS',
        FAILURE: 'GET_USER_PROFILE_FAILURE',
        PENDING: 'GET_USER_PROFILE_PENDING',
    },

    UPDATE_USER_PROFILE : {
        SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
        FAILURE: 'UPDATE_USER_PROFILE_FAILURE',
        PENDING: 'UPDATE_USER_PROFILE_PENDING',
    },

}

export default UserProfileTypes;